import {useHashWizard} from '../../../../../common/components/wizards/useHashWizard';
import {useParams} from 'react-router-dom';
import {useControllers} from '../../../../../../../common/helpers/react/hooks/useControllers';
import {asNumber} from '../../../../../../../common/helpers/converters/asNumber';
import {default as React} from 'react';
import GroupWizardStepTemplate from '../GroupWizardStepTemplate';
import GroupWizardSettingsAccordion from './GroupWizardSettingsAccordion';

export default function GroupWizardSettingsStepPresenter() {
    const {id} = useParams();

    const wh = useHashWizard();

    const groups = useControllers().groups;
    const groupId = asNumber(id);
    const group = groups.getGroupById$(groupId).useState() ?? undefined;

    return (
        <GroupWizardStepTemplate wizardHelpers={wh} group={group}>
            <div>
                <GroupWizardSettingsAccordion/>
            </div>
        </GroupWizardStepTemplate>
    );
}